import { render } from "./SidebarComponent.vue?vue&type=template&id=4098372a&ts=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=ts"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__